/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
 */

/**
 * Ensure a given size has a unit
 * @param {string|number} size
 * @param {string} unit - the unit to append to the size
 * @returns {string} the size with a unit or it's original value if falsy
 */
export function withUnit(size, unit = 'px') {
    const isAStringWithoutUnit = typeof size === 'string' && size.length > 0 && `${parseFloat(size)}` === size;
    const isANumber = typeof size === 'number' && !isNaN(size);
    return isANumber || isAStringWithoutUnit ? `${size}${unit}` : size;
}

/**
 * Check if the given size, based on it's unit, is responsive (adapts to the container or the page)
 * @param {string|number} size - the size like '12px' or '50%'
 * @returns {boolean} true if the size uses a responsive unit
 */
export function isResponsive(size) {
    if (size) {
        const responsiveUnits = ['%', 'auto', 'vh', 'vw', 'em', 'rem', 'vmin', 'vmax'];
        const unit = `${size}`.replace(/[0-9 .-]*/, '').trim();
        if(unit){
            return responsiveUnits.includes(unit);
        }
    }
    return false;
}
